import { useEffect, useState } from 'react'
import { UserStatus } from '../../types/UserStatus.enum'
import { getLocalUserStatus } from '../helpers/userStatusStorage'

export const useAmpUserStatus = (): UserStatus => {
  const [status, setStatus] = useState<UserStatus>(() => getLocalUserStatus())

  useEffect(() => {
    const newStatus = getLocalUserStatus()
    setStatus(newStatus)
  }, [])

  return status
}
